import React from 'react';

export function Card({ icon, title, children }) {
    return (
        <div className="bg-white rounded-2xl p-6 shadow-sp hover:shadow-sp-hover transition text-center">
            <div className="text-4xl mb-4">{icon}</div>
            <h3 className="text-xl font-black text-sp-text">{title}</h3>
            <p className="text-sp-body text-sm mt-2">{children}</p>
        </div>
    );
}